/// <reference path='../../../../typings/index.d.ts' />
/// <reference path='controls.module.ts' />

module Meevo.Components.Controls {
    'use strict';
    import IScope = angular.IScope;

    interface IDateObject {
        hour: number,
        minutes: number,
        seconds: number,
        milliseconds: number,
        meridian: string,
    }

    interface IMeevoTimeFrameScope extends IScope {
        from: Date,
        to: Date,
        showAmPm: boolean,
        showSeconds: boolean,
        hours: Array<number>,
        mins: Array<number>,
        seconds: Array<number>,
        meridians: Array<string>,
        selectedFrom: IDateObject,
        selectedTo: IDateObject,
        validate(from: IDateObject, to: IDateObject): void,
        setFullDay(): void,
        defaultValueTo?: Date,
        defaultValueFrom?: Date,
        defaultFullDay?: boolean,
        dateFrom?: Date,
        dateTo?: Date,
        hideTimeFrom?: boolean,
        hideTimeTo?: boolean
    }

    export class MeevoTimeFrame implements angular.IDirective {
        standard: Array<number> = [];
        military: Array<number> = [];
        mins: Array<number> = [];
        seconds: Array<number> = [];
        meridians: Array<string> = ['am', 'pm'];
        require = '^form';
        scope = {
            from: '=',
            to: '=',
            showAmPm: '=?',
            showSeconds: '=?',
            contentKeyFrom: '@',
            contentKeyTo: '@',
            disabled: '=ngDisabled',
            isHideFullDayButton: '=?',
            tabIndex: '=tabIndex',
            defaultValueTo: '=?',
            defaultValueFrom: '=?',
            defaultFullDay: '=?',
            dateFrom: '=?',
            dateTo: '=?',
            hideTimeFrom: '=?',
            hideTimeTo: '=?'
        };

        templateUrl = 'app/components/controls/timeFrameTemplate.html';

        link = (scope: IMeevoTimeFrameScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, formController: ng.IFormController) => {
            scope.hours = scope.showAmPm === true ? this.standard : this.military;
            scope.mins = this.mins;
            scope.seconds = this.seconds;
            scope.meridians = this.meridians;
            scope.selectedFrom = {
                hour: null,
                minutes: null,
                seconds: null,
                milliseconds: 0,
                meridian: null
            };
            scope.selectedTo = angular.copy(scope.selectedFrom);
            scope.selectedTo.milliseconds = 999;

            // parse income date object into time intervals
            scope.selectedFrom = MeevoTimeFrame.formatDateIntoModel(scope.from || moment().startOf('day').toDate(), scope.selectedFrom, scope.showAmPm);
            scope.selectedTo = MeevoTimeFrame.formatDateIntoModel(scope.to || moment().endOf('day').toDate(), scope.selectedTo, scope.showAmPm);

            if (scope.defaultValueFrom) {
                scope.selectedFrom = MeevoTimeFrame.formatDateIntoModel(scope.defaultValueFrom, scope.selectedFrom, scope.showAmPm);
            }
            if (scope.defaultValueTo) {
                scope.selectedTo = MeevoTimeFrame.formatDateIntoModel(scope.defaultValueTo, scope.selectedTo, scope.showAmPm);
            }

            /**
             * Watch changing for 'From' select
             * */
            scope.$watch(() => {
                return scope.selectedFrom;
            }, (newVal, oldVal) => {
                if (newVal && newVal !== oldVal) {
                    scope.validate(newVal, scope.selectedTo);
                }
            }, true);

            /**
             * Watch changing for 'from' date
             * */
            scope.$watch(() => {
                return scope.from;
            }, (newVal, oldVal) => {
                if (newVal && newVal !== oldVal) {
                    scope.selectedFrom = MeevoTimeFrame.formatDateIntoModel(newVal, scope.selectedFrom, scope.showAmPm);
                }
            });

            /**
             * Watch changing for 'to' date
             * */
            scope.$watch(() => {
                return scope.to;
            }, (newVal, oldVal) => {
                if (newVal && newVal !== oldVal) {
                    scope.selectedTo = MeevoTimeFrame.formatDateIntoModel(newVal, scope.selectedTo, scope.showAmPm);
                }
            });

            /**
             * Watch related dates changes
             * */
            scope.$watch(() => [scope.dateFrom, scope.dateTo], () => scope.validate(scope.selectedFrom, scope.selectedTo), true);

            /**
             * Watch changing for 'To' select
             * */
            scope.$watch(() => {
                return scope.selectedTo;
            }, (newVal, oldVal) => {
                if (newVal && newVal !== oldVal) {
                    scope.validate(scope.selectedFrom, newVal);
                }
            }, true);

            /**
             * Compare two Date object
             * */
            scope.validate = (from: IDateObject, to: IDateObject) => {
                let mFrom = MeevoTimeFrame.formatModelIntoMoment(from, scope.dateFrom);
                let mTo = MeevoTimeFrame.formatModelIntoMoment(to, scope.dateTo);
                let dateFromProperty = scope.dateFrom;
                let dateToProperty = scope.dateTo;

                if ((mFrom.isBefore(mTo) || mFrom.isSame(mTo)) || (dateFromProperty && dateToProperty && moment(dateFromProperty).diff(moment(dateToProperty), 'days') < 0)) {
                    formController['timeFrameForm'].$setValidity('timerange', true);
                    scope.from = mFrom.toDate();
                    scope.to = mTo.toDate();
                } else {
                    formController['timeFrameForm'].$setValidity('timerange', false);
                }
            };

            /**
             * Set time range for full day
             * */
            scope.setFullDay = () => {
                scope.selectedFrom.hour = scope.showAmPm ? 12 : 0;
                scope.selectedFrom.minutes = 0;
                scope.selectedFrom.seconds = 0;
                scope.selectedFrom.meridian = scope.showAmPm ? 'am' : null;
                scope.selectedTo.hour = scope.showAmPm ? 11 : 23;
                scope.selectedTo.minutes = 59;
                scope.selectedTo.seconds = 59;
                scope.selectedTo.meridian = scope.showAmPm ? 'pm' : null
            };

            if (scope.defaultFullDay) {
                scope.setFullDay();
            }

            scope.validate(scope.selectedFrom, scope.selectedTo);
        };

        constructor() {
            // bootstrap time values
            for (let i = 0; i < 60; i += 1) {
                if (i <= 12) {
                    this.standard.push(i);
                    this.military.push(i);
                } else if (i <= 23) {
                    this.military.push(i);
                }
                this.mins.push(i)
                this.seconds.push(i)
            }
            this.standard.shift();
        }

        /**
         * Get income date object and split it by time intervals - hour, minute, meridian
         * */
        static formatDateIntoModel(date: Date, model: IDateObject, showAmPm: boolean): IDateObject {
            let d = moment(date);

            if (d.isValid()) {

            } else {
                d = moment();
            }

            model.hour = showAmPm === true ? Number(d.format('h')) : Number(d.format('HH'));
            model.minutes = Number(d.format('mm'));
            model.seconds = Number(d.format('ss'));
            model.meridian = showAmPm === true ? d.format('a') : null;

            return model;
        };

        /**
         * Get Date object, based on time intervals and return Moment.js object with current date
         * */
        static formatModelIntoMoment(model: IDateObject, defaultDate: Date = new Date()): moment.Moment {
            let d = moment(defaultDate);

            if (model.meridian) {
                let h: number;

                if (model.meridian === 'am') {
                    h = model.hour !== 12 ? model.hour : 0;
                }
                else if (model.meridian === 'pm') {
                    h = model.hour !== 12 ? model.hour + 12 : 12;
                }
                d.set('hour', h);
            } else {
                d.set('hour', model.hour);
            }
            d.set('minute', model.minutes);
            d.set('second', model.seconds);
            d.set('millisecond', model.milliseconds);

            return d;
        }

        static factory(): angular.IDirectiveFactory {
            return () => {
                return new MeevoTimeFrame();
            }
        }
    }

    angular.module('meevo.components.controls')
        .directive('meevoTimeFrame', MeevoTimeFrame.factory());
}
